import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const Divider = ({customClassNames = ''}) => {

  return <div className={classNames(styles.divider, customClassNames)}/>;
};

export default Divider;
